let template = () => `
  <div id="screen-heading">Domain Model<span class='screen-map-name'></span> & Search Trace Visualiser<span class='screen-trace-name'></span></div>
`;
export default template;
